'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _containers = require('containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  /**
   * Please keep routes in alphabetical order
   */
  return _react2.default.createElement(
    _reactRouter.Route,
    { path: '/', component: _containers.App, history: _reactRouter.hashHistory },
    _react2.default.createElement(
      _reactRouter.Route,
      null,
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.NotFound }),
      _react2.default.createElement(_reactRouter.Route, { path: '/survey/:clientId/:locationId/:surveyId/:providerId', component: _containers.Survey }),
      _react2.default.createElement(_reactRouter.Route, { path: '/survey/:clientId/:locationId/:surveyId/:providerId/:code', component: _containers.Survey }),
      _react2.default.createElement(_reactRouter.Route, { path: '/error', component: _containers.NotFound }),
      _react2.default.createElement(_reactRouter.Route, { path: '/unsubscribe/:clientId/:unsubscribeCode', component: _containers.Unsubscribe }),
      _react2.default.createElement(_reactRouter.Route, { path: '/unsubscribe/v2/:clientId/:unsubscribeCode', component: _containers.UnsubscribeV2 }),
      _react2.default.createElement(_reactRouter.Route, { path: '/:clientId/unsubscription', component: _containers.Unsubscription }),
      _react2.default.createElement(_reactRouter.Route, { path: '*', component: _containers.NotFound, status: 404 })
    )
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/routes.js
// module id = 1574
// module chunks = 0